import apiClient from './apiClient';
import { getLastSearchContext, setLastSearchContext } from '../utils/trackingState';

function silentPost(path, payload) {
  return apiClient.post(path, payload, { suppressError: true }).catch(() => null);
}

export async function trackSearch(payload = {}) {
  const data = await silentPost('/tracking/searches', payload);
  if (data?.id) {
    setLastSearchContext({
      id: data.id,
      query: payload.query || '',
      source: payload.source || 'search',
      tracked_at: new Date().toISOString(),
    });
  }
  return data;
}

export function trackShopVisit(payload = {}) {
  return silentPost('/tracking/visited_shops', {
    ...payload,
    search_id: payload.search_id || getLastSearchContext()?.id || null,
  });
}

export function trackStockVisit(payload = {}) {
  return silentPost('/tracking/visited_stocks', {
    ...payload,
    search_id: payload.search_id || getLastSearchContext()?.id || null,
  });
}

export function attachGuestHistory() {
  return silentPost('/buyer/history/attach_guest', {});
}

export function getBuyerHistory() {
  return apiClient.get('/buyer/history', { suppressError: true });
}
